module.exports = __webpack_public_path__ + "media/big_win.6f71049b.mp3";